<template>
    <el-dialog
        :visible.sync="showForm"
        :close-on-click-modal="false"
        append-to-body>

        <billing-inner :billing_period_id="data_id"
                       :no_save_btn="false"
                       @status-updated="(status) => { this.period_status = status; }"></billing-inner>
        <billing-addons :billing_period_id="data_id" :status="period_status"></billing-addons>
        <billing-notes :billing_period_id="data_id"></billing-notes>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import BillingInner from "./billing-inner";
import BillingNotes from "../../../BudgetNotes/vue/billing-notes";
import BillingAddons from "../../../BudgetAddOns/vue/billing-addons";

export default {
      components: {BillingInner, BillingNotes, BillingAddons},
      props: [
            'show',
            'data_id',
            'status'
        ],
        data() {
            return {
                campaignId: null,
                period_status: this.status,
            };
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                this.showForm = false;
            }
        }
    }
</script>

<style>
  .cd-section {
    margin-top: 10px;
  }
</style>